'use strict';

var $ = require("jquery");
var contactPanelJade = require('vhi-ui-framework/src/main/jade/templates/groupSchemeContactPanel.jade');

function render(schemeData) {
    var vhiContactList = schemeData.vhiContacts;
    var schemeContactList = schemeData.schemeContacts;
    var dataObj = {
        groupSchemeCompany: schemeData.schemeName,
        groupSchemeNumber: schemeData.schemeId,
        webVhiContact: (vhiContactList && vhiContactList.length > 0) ? vhiContactList[0] : null,
        webCompanyContact: (schemeContactList && schemeContactList.length > 0) ? schemeContactList[0] : null
    };
    var html = contactPanelJade(dataObj);
    var $placeHolder = $('#scheme-specific-contact-panel');
    $placeHolder.html(html);
}

module.exports.render = render;


//////////////////
// WEBPACK FOOTER
// ./src/shared/scripts/modules/contactPanel.js
// module id = rzgQ
// module chunks = 14